import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  CancelDiscountFreeRangePayload,
  CreateDiscountFreeRangePayload,
  ImportDiscountFreeRangePayload,
  UpdateDiscountFreeRangePayload,
  UpdateDiscountFreeRangeStatusPayload,
} from '../../../models/parking/discount-free-range.model';

@Injectable({ providedIn: 'root' })
export class ApiDiscountFreeRangeService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getDiscountFreeRangeForTable(params: {
    siteId: number;
    page?: number;
    pageSize?: number;
    searchText?: string;
    startDate?: string;
    endDate?: string;
    isEnabled?: boolean | null;
  }): Observable<unknown> {
    const query: Record<string, string | number | boolean> = {
      siteId: params.siteId,
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 20,
    };
    if (params.searchText) query['searchText'] = params.searchText;
    if (params.startDate) query['startDate'] = params.startDate;
    if (params.endDate) query['endDate'] = params.endDate;
    if (params.isEnabled != null) query['isEnabled'] = params.isEnabled;
    return this.apiMethodService.request('/DiscountFreeRange/getDiscountFreeRangeForTable', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getDiscountFreeRangeForTable',
      token: this.token,
      headerOnly: false,
      params: query,
    });
  }

  getDiscountFreeRangeById(id: number): Observable<unknown> {
    return this.apiMethodService.request('/DiscountFreeRange/getDiscountFreeRangeById', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getDiscountFreeRangeById',
      token: this.token,
      headerOnly: false,
      params: { id },
    });
  }

  getDiscountFreeRangeLogs(freeRangeId: number, page = 1, pageSize = 20): Observable<unknown> {
    return this.apiMethodService.request('/DiscountFreeRange/getDiscountFreeRangeLogs', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getDiscountFreeRangeLogs',
      token: this.token,
      headerOnly: false,
      params: { freeRangeId, page, pageSize },
    });
  }

  createDiscountFreeRange(body: CreateDiscountFreeRangePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request('/DiscountFreeRange/createDiscountFreeRange', 'POST', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'createDiscountFreeRange',
      token: this.token,
      headerOnly: false,
      body,
    });
  }

  updateDiscountFreeRange(body: UpdateDiscountFreeRangePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request('/DiscountFreeRange/updateDiscountFreeRange', 'PATCH', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'updateDiscountFreeRange',
      token: this.token,
      headerOnly: false,
      body,
    });
  }

  updateDiscountFreeRangeStatus(body: UpdateDiscountFreeRangeStatusPayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request('/DiscountFreeRange/updateDiscountFreeRangeStatus', 'PATCH', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'updateDiscountFreeRangeStatus',
      token: this.token,
      headerOnly: false,
      body,
    });
  }

  cancelDiscountFreeRange(body: CancelDiscountFreeRangePayload): Observable<ActionBackOfficeResponse> {
    return this.apiMethodService.request('/DiscountFreeRange/cancelDiscountFreeRange', 'PATCH', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'cancelDiscountFreeRange',
      token: this.token,
      headerOnly: false,
      body,
    });
  }

  importDiscountFreeRange(body: ImportDiscountFreeRangePayload): Observable<unknown> {
    return this.apiMethodService.request('/DiscountFreeRange/importDiscountFreeRange', 'POST', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'importDiscountFreeRange',
      token: this.token,
      headerOnly: false,
      body,
    });
  }
}
